var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIconNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 239 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.911 404.876L36.498 323.248C28.0702 313.644 34.9197 298.561 47.7103 298.561H190.537C193.399 298.558 196.202 299.381 198.609 300.93C201.016 302.48 202.925 304.69 204.109 307.297C205.292 309.903 205.698 312.796 205.28 315.627C204.861 318.459 203.636 321.11 201.749 323.263L130.336 404.862C128.938 406.461 127.215 407.743 125.281 408.621C123.347 409.499 121.248 409.954 119.124 409.954C117 409.954 114.9 409.499 112.966 408.621C111.033 407.743 109.309 406.461 107.911 404.862V404.876Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.331 73.1236L201.744 154.752C210.172 164.356 203.323 179.439 190.532 179.439L47.7053 179.439C44.8427 179.442 42.0401 178.619 39.6331 177.07C37.2261 175.52 35.3167 173.31 34.1336 170.703C32.9505 168.097 32.5438 165.204 32.9622 162.373C33.3807 159.541 34.6065 156.89 36.493 154.737L107.906 73.1385C109.304 71.5391 111.027 70.2573 112.961 69.379C114.895 68.5007 116.995 68.0463 119.119 68.0463C121.243 68.0463 123.342 68.5007 125.276 69.379C127.21 70.2573 128.933 71.5391 130.331 73.1385V73.1236Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconNone);
export default __webpack_public_path__ + "static/media/sortIconNone.f6751336.svg";
export { ForwardRef as ReactComponent };